<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";
import AdultJaw from "./AdultJaw.vue";
import ChildJaw from "./ChildJaw.vue";

const props = defineProps({
  modelValue: {
    type: Number,
    default: 0,
  },
  jawType: {
    type: String,
    required: true,
  }
});

const emit = defineEmits(['update:modelValue', 'hoverTooth']);

const selectedTooth = ref(props.modelValue);

watch(selectedTooth, async (value) => {
  emit('update:modelValue', value);
})
</script>

<template>
  <div class="content-center text-center">
    <adult-jaw
      v-if="'adult' === jawType"
      v-model="selectedTooth"
    />
    <child-jaw
      v-if="'child' === jawType"
      v-model="selectedTooth"
    />
  </div>
</template>
